import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { User } from '../../domain/entities/User';

export interface NavItem {
  name: string;
  path: string;
  icon: React.ReactNode;
  key: string;
  roles?: string[];
}

interface UseNavigationReturn {
  navigate: (path: string) => void;
  currentPath: string;
  getFilteredNavItems: (navItems: NavItem[], user: User | null) => NavItem[];
  isCurrentRoute: (path: string) => boolean;
}

export const useNavigation = (): UseNavigationReturn => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigate = useCallback((path: string) => {
    navigate(path);
  }, [navigate]);

  const getFilteredNavItems = useCallback((navItems: NavItem[], user: User | null): NavItem[] => {
    if (!user) return [];
    
    return navItems.filter(item => {
      if (!item.roles || item.roles.length === 0) return true;
      return item.roles.includes(user.role);
    });
  }, []);

  const isCurrentRoute = useCallback((path: string): boolean => {
    return location.pathname === path;
  }, [location.pathname]);

  return {
    navigate: handleNavigate,
    currentPath: location.pathname,
    getFilteredNavItems,
    isCurrentRoute,
  };
};